import { render, staticRenderFns } from "./menu-left.vue?vue&type=template&id=c2f8f3e2&scoped=true"
import script from "./menu-left.vue?vue&type=script&lang=js"
export * from "./menu-left.vue?vue&type=script&lang=js"
import style0 from "./menu-left.vue?vue&type=style&index=0&id=c2f8f3e2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f8f3e2",
  null
  
)

export default component.exports